import "../styles/styles.scss";
import React, { useCallback, useState } from "react";
import X from "../assets/x.svg";
import { compose } from "redux";
import classNames from "classnames";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";
import withTranslations from "../../../../../hocs/withTranslations";
import LandingTypography from "../../../landingPage/pages/Homepage/components/LandingTypography";

export const CLOSING_DELAY = 200;

const NewModal = ({
  title,
  cancelButtonText,
  acceptButtonText,
  acceptButton,
  acceptButtonDisabled = false,
  acceptButtonLoading = false,
  onClose,
  children,
  footer,
  onAccept,
  onCancel,
  translate,
  hideModal,
  canHide,
  hideOnAccept = true,
  hideOnCancel = true,
  showCloseButton = true,
  subtitle,
  obstructive = true,
  maxWidthClassName = "max-w-130"
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const isDesktop = useIsDesktop();
  const isNonObstructive = !obstructive;
  const showHeader = Boolean(title) || showCloseButton;
  const showBuiltInButtons =
    !footer && (cancelButtonText || acceptButtonText || acceptButton);

  const handleClosing = useCallback(
    async (callback, skipCanHide = false) => {
      if (
        !skipCanHide &&
        ((typeof canHide === "function" && !canHide()) || canHide === false)
      ) {
        await callback?.();
        return;
      }

      setIsClosing(true);

      setTimeout(async () => {
        hideModal?.();

        if (typeof callback === "function") {
          await callback?.();
        }
      }, CLOSING_DELAY);
    },
    [hideModal, canHide]
  );

  return (
    <LandingTypography
      className={classNames("plans new-modal", {
        "new-modal_closing": isClosing && isDesktop,
        "new-modal_mobile-closing": isClosing && !isDesktop,
        "new-modal_non-obstructive": isNonObstructive
      })}
    >
      {isNonObstructive ? null : (
        <div className={"bg-black-5 absolute w-full h-full"} />
      )}
      <div
        className={classNames({ body: isDesktop, "mobile-body": !isDesktop })}
      >
        <div
          className={classNames("bg-white", {
            [`${maxWidthClassName} p-7 bg-white rounded-2xl mx-auto`]: isDesktop,
            "border border-gray shadow-card-lg": isNonObstructive,
            "p-4 rounded-t-1xl": !isDesktop
          })}
        >
          {showHeader ? (
            <div className={"flex justify-between align-center"}>
              {title ? (
                <h1
                  className={classNames("font-semibold mb-0 mt-0 normal-case", {
                    "text-2xl.1": isDesktop,
                    "text-2xl": !isDesktop
                  })}
                >
                  {title}
                </h1>
              ) : null}
              {showCloseButton ? (
                <button
                  onClick={async () => {
                    await handleClosing(onClose);
                  }}
                  type={"button"}
                  className={classNames("button-5", {
                    "p-3": isDesktop,
                    "p-2": !isDesktop,
                    "ml-auto": !title
                  })}
                >
                  <img
                    src={X}
                    alt={translate("Close")}
                    width={16}
                    height={16}
                    className={"flex shrink-0"}
                  />
                </button>
              ) : null}
            </div>
          ) : null}
          {subtitle ? (
            <p className={"text-xs line-height-160 text-black-8 mb-10 mt-3"}>
              {subtitle}
            </p>
          ) : null}
          {children ? (
            <div
              className={classNames({
                children: isDesktop,
                "mobile-children": !isDesktop,
                "mt-6 mb-8": isDesktop && showHeader,
                "mb-8": isDesktop && !showHeader,
                "mt-4 mb-6": !isDesktop && showHeader,
                "mb-6": !isDesktop && !showHeader
              })}
            >
              {children}
            </div>
          ) : null}
          {footer ? (
            footer
          ) : showBuiltInButtons ? (
            <div
              className={classNames("flex gap-4", {
                "justify-end ": isDesktop,
                "flex-col": !isDesktop
              })}
            >
              {cancelButtonText ? (
                <button
                  type="button"
                  onClick={async () => {
                    if (hideOnCancel) {
                      await handleClosing(onCancel, true);
                    } else {
                      await onCancel?.();
                    }
                  }}
                  className={"button-1 button-1_clear"}
                >
                  {cancelButtonText}
                </button>
              ) : null}
              {acceptButtonText ? (
                <button
                  type="button"
                  disabled={acceptButtonDisabled || acceptButtonLoading}
                  onClick={async () => {
                    if (acceptButtonDisabled || acceptButtonLoading) {
                      return;
                    }
                    if (hideOnAccept) {
                      await handleClosing(onAccept);
                    } else {
                      await onAccept?.();
                    }
                  }}
                  className={classNames("button-1", "disabled.button")}
                >
                  {acceptButtonLoading ? (
                    <i className="fal fa-spinner fa-spin text-black font-semibold mr-2" />
                  ) : null}
                  {acceptButtonText}
                </button>
              ) : acceptButton ? (
                acceptButton
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </LandingTypography>
  );
};

export default compose(withTranslations)(NewModal);
